module.exports = __webpack_public_path__ + "static/media/4_r_lampa_pol_88.7_61.11.ca2b4324.png";